export default {"src":"/_next/static/image/public/images/ic_floppy_blue.22fee0281ba8e91735ead947ff88a62b.svg","height":21,"width":20};